<template>
  <div class="mt-2 px-0 py-5 text-center relative w-full">
    <spinner :busy="loading" color="#000" class="mt-12"></spinner>

    <vue-word-cloud
      v-if="words.length && !loading"
      style="height: 360px; width: 100%;"
      :words="words"
      :color="generateColor"
      :font-family="fontFamily"
      :animation-duration="animationDuration"
      :animation-easing="animationEasing"
      :animation-overlap="animationOverlap"
      :rotation="getRotation"
    />

    <p
      v-if="!words.length && !loading && false"
      class="mt-12 text-xl sm:text-2xl font-extralight text-gray-400"
    >
    {{ translations.no_answers_yet }}
    </p>
  </div>
</template>

<script>
import Spinner from '@/Shared/Spinner';
import VueWordCloud from 'vuewordcloud';
import { sample } from 'lodash';

export default {
  name: 'LiveResultsWordCloud',

  metaInfo() {
    return {
      title: `Live Results`,
    };
  },

  components: {
    Spinner,
    [VueWordCloud.name]: VueWordCloud,
  },

  props: ['session', 'translations'],

  data() {
    return {
      loading: false,
      // words: [
      //   ['romance', 19],
      //   ['horror', 3],
      //   ['fantasy', 7],
      //   ['adventure', 3],
      //   ['Filialkirche St', 20],
      // ],
      words: [],
      fontFamily: 'Gilroy',
      color: this.generateColor,

      animationDuration: 2000,
      animationEasing: 'linear',
      animationOverlap: 0.2,

      rotation: this.getRotation,
      refreshIntervalId: null,
    };
  },

  mounted() {
    Echo.channel('markencode-app.session.' + this.session.id).listen(
      '.participant.answered',
      (e) => {
        this.load();
      }
    );

    this.load();

    this.refreshIntervalId = window.setInterval(() => {
      this.load();
    }, 10000);
  },

  destroyed() {
    if (this.refreshIntervalId) {
      clearInterval(this.refreshIntervalId);
      this.refreshIntervalId = null;
    }
  },

  methods: {
    load() {
      if (this.loading) {
        return;
      }

      this.loading = true;

      window.axios
        .post(
          this.route('live-results.answers', {
            id: this.session.uuid,
          }),
          {}
        )
        .then((response) => {
          this.words = response.data.answers || [];
          this.loading = false;
        })
        .catch((error) => {
          console.warn('live-results.wordcloud.load failed', error?.response?.status, error?.message);
          this.loading = false;
        });
    },

    generateColor() {
      var colors = ['#53c9ff', '#4bb5e6', '#42a1cc', '#3a8db3'];

      return sample(colors);
    },

    getRotation() {
      var rotations = [0, 1 / 4];

      return sample(rotations);
    },
  },
};
</script>
